import './types';
import { ThemeOptions } from '@mui/material';

import * as Breakpoints from '../breakpoints/theme';
import * as Colors from '../color/theme';
import * as Spacing from '../spacing/theme';
import * as Typography from '../typography/theme';
import * as AppBarComponents from '../appbar/theme';
import * as ButtonComponents from '../button/theme';
import * as IconButtonComponents from '../iconButton/theme';
import * as CheckboxComponents from '../checkbox/theme';
import * as RadioComponents from '../radio/theme';
import * as SwitchComponents from '../switch/theme';
import * as FormComponents from '../form/theme';
import * as AvatarComponent from '../avatar/theme';
import * as BadgeComponent from '../badge/theme';
import * as TextFieldComponent from '../textfield/theme';
import * as InputBaseComponent from '../inputBase/theme';
import * as InputAdornment from '../inputAdornment/theme';
import * as Tabs from '../tabs/theme';
import * as Card from '../card/theme';
import * as Paper from '../paper/theme';
import * as List from '../list/theme';
import * as Autocomplete from '../autocomplete/theme';
import * as Select from '../select/theme';
import * as InputLabel from '../inputLabel/theme';
import * as FormHelperText from '../formHelperText/theme';
import * as Menu from '../menu/theme';
import * as Chip from '../chip/theme';
import * as Breadcrumbs from '../breadcrumbs/theme';
import * as Dialog from '../dialog/theme';
import * as OutlinedInput from '../outlinedInput/theme';
import * as ButtonGroup from '../buttonGroup/theme';
import * as ToggleButtonGroup from '../toggleButton/theme';
import * as Popover from '../popover/theme';

export const cxnTheme: ThemeOptions = {
  ...Breakpoints,
  ...Colors,
  ...Spacing,
  ...Typography,
  components: {
    ...AppBarComponents,
    ...ButtonComponents,
    ...IconButtonComponents,
    ...CheckboxComponents,
    ...RadioComponents,
    ...SwitchComponents,
    ...FormComponents,
    ...AvatarComponent,
    ...BadgeComponent,
    ...TextFieldComponent,
    ...InputBaseComponent,
    ...InputAdornment,
    ...Tabs,
    ...Card,
    ...Paper,
    ...List,
    ...Autocomplete,
    ...Select,
    ...InputLabel,
    ...FormHelperText,
    ...Menu,
    ...Chip,
    ...Breadcrumbs,
    ...Dialog,
    ...OutlinedInput,
    ...ButtonGroup,
    ...ToggleButtonGroup,
    ...Popover,
  },
};
